import * as CONSTANTS from '../../constants';
import config from '../../../config';

export default {

    /**
     * Indicates revenue is being fetched
     *
     * @param state
     */
    [CONSTANTS.STAT_REVENUE_PERIOD_PENDING](state) {
        state.periodRevenue = {...state.periodRevenue, loading: true, error: false, noContent: false};
        state.periodBookings = {...state.periodBookings, loading: true, error: false, noContent: false};
        state.statSites = {...state.statSites, loading: true, error: false, noContent: false};
    },

    /**
     * Updates revenue and bookings
     *
     * @param state
     * @param revenue
     * @param bookings
     * @param sites
     */
    [CONSTANTS.STAT_REVENUE_PERIOD_SUCCESS](state, {revenue, bookings, sites}) {
        state.periodRevenue = {...state.periodRevenue, value: revenue, loading: false, error: false, noContent: false};
        state.periodBookings = {
            ...state.periodBookings,
            value: bookings,
            loading: false,
            error: false,
            noContent: false
        };
        state.statSites = {...state.statSites, loading: false, error: false, noContent: false};
        state.sites = sites;
    },

    /**
     * Indicates that an error occured while fetching the revenue
     *
     * @param state
     */
    [CONSTANTS.STAT_REVENUE_PERIOD_FAILURE](state) {
        state.periodRevenue = {...state.periodRevenue, loading: false, error: true, noContent: false};
        state.periodBookings = {...state.periodBookings, loading: false, error: true, noContent: false};
        state.statSites = {...state.statSites, loading: false, error: true, noContent: false};
        state.selectedSite = undefined;
        state.sites = undefined;

    },

    /**
     * Indicates that no content was found
     *
     * @param state
     */
    [CONSTANTS.STAT_REVENUE_PERIOD_NO_CONTENT](state) {
        state.periodRevenue = {...state.periodRevenue, value: undefined, loading: false, error: false, noContent: true};
        state.periodBookings = {
            ...state.periodBookings,
            value: undefined,
            loading: false,
            error: false,
            noContent: true
        };
        state.statSites = {...state.statSites, loading: false, error: false, noContent: true};
        state.selectedSite = undefined;
        state.sites = undefined;
    },

    /**
     * Indicates revenue is being fetched
     *
     * @param state
     */
    [CONSTANTS.STAT_REVENUE_TOTAL_PENDING](state) {
        state.totalRevenue = {...state.totalRevenue, loading: true, error: false, noContent: false};
        state.totalBookings = {...state.totalBookings, loading: true, error: false, noContent: false};
    },

    /**
     * Updates revenue and bookings
     *
     * @param state
     * @param revenue
     * @param bookings
     */
    [CONSTANTS.STAT_REVENUE_TOTAL_SUCCESS](state, {revenue, bookings}) {
        state.totalRevenue = {...state.totalRevenue, value: revenue, loading: false, error: false, noContent: false};
        state.totalBookings = {...state.totalBookings, value: bookings, loading: false, error: false, noContent: false};
    },

    /**
     * Indicates that an error occured while fetching the revenue
     *
     * @param state
     */
    [CONSTANTS.STAT_REVENUE_TOTAL_FAILURE](state) {
        state.totalRevenue = {...state.totalRevenue, loading: false, error: true, noContent: false};
        state.totalBookings = {...state.totalBookings, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that no content was found
     *
     * @param state
     */
    [CONSTANTS.STAT_REVENUE_TOTAL_NO_CONTENT](state) {
        state.totalRevenue = {...state.totalRevenue, value: undefined, loading: false, error: false, noContent: true};
        state.totalBookings = {...state.totalBookings, value: undefined, loading: false, error: false, noContent: true};
    },

    /**
     * Updates the currently selected period
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.STAT_UPDATE_BOOKING_PERIOD](state, payload) {
        state.bookingPeriod = {...state.bookingPeriod, to: payload.data.to, from: payload.data.from};
    },

    /**
     * Updates the currently selected period
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.STAT_UPDATE_ARRIVAL_PERIOD](state, payload) {
        state.arrivalPeriod = {...state.arrivalPeriod, to: payload.data.to, from: payload.data.from};
    },

    /**
     * Updates the currently selected site
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.STAT_UPDATE_SELECTED_SITE](state, payload) {
        state.selectedSite = payload.data;
    },

    /**
     * Updates the currently selected site in the mobile list
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.STAT_UPDATE_SELECTED_STAT_LIST_ITEM](state, payload) {
        state.statList = {...state.statList, selectedItem: payload}
    },

    /**
     * Updates the currently selected site in the mobile list
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.STAT_UPDATE_DROPDOWN_SITES](state, payload) {
        state.statSites = {...state.statSites, predicate: payload}
    },

    /**
     * Updates the currently selected site in the mobile list
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.STAT_UPDATE_DROPDOWN_ACCOMMODATION](state, payload) {
        state.statInventory = {...state.statInventory, predicate: payload}
    },

    /**
     * Updates the currently selected site in the mobile list
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.STAT_UPDATE_DROPDOWN_LIST](state, payload) {
        state.statList = {...state.statList, predicate: payload}
    },

    [CONSTANTS.STAT_RESET_STATE](state) {
        state.season = {...state.season, from: config.business.SEASON_DATE_START, to: config.business.SEASON_DATE_END};
        state.bookingPeriod = {...state.bookingPeriod, from: config.business.SEASON_DATE_START, to: config.business.SEASON_DATE_END};
        state.arrivalPeriod = {...state.arrivalPeriod, from: config.business.SEASON_DATE_START, to: config.business.SEASON_DATE_END};
        state.totalRevenue = {...state.totalRevenue, value: undefined, loading: false, error: false, noContent: false};
        state.totalBookings = {...state.totalBookings, value: undefined, loading: false, error: false, noContent: false};
        state.periodRevenue = {...state.periodRevenue, value: undefined, loading: false, error: false, noContent: false};
        state.periodBookings = {...state.periodBookings, value: undefined, loading: false, error: false, noContent: false};
        state.statSites = {...state.statSites, loading: false, error: false, noContent: false, predicate: "revenue", predicates: ["revenue", "bookings"]};
        state.statList = {...state.statList, selectedItem: undefined, predicate: "revenue", predicates: ["revenue", "bookings"]};
        state.statInventory = {...state.statInventory, predicate: "revenue", predicates: ["revenue", "bookings"]};
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/stats/mutations.js